import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, onPrepareHeaders } from "@/redux/services/helpers";
import {
  RESOURCE_SHARE_REDUCER_PATH,
  RESOURCE_SHARE_RELATED_TAGS,
} from "@/modules/contacts/features/lender/utils/resource-share-service-tags";

export const lenderResourceShareService = createApi({
  reducerPath: RESOURCE_SHARE_REDUCER_PATH,
  tagTypes: RESOURCE_SHARE_RELATED_TAGS,
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: onPrepareHeaders,
  }),
  endpoints: () => ({}),
});

